export default "/_next/static/images/ca6c7284fc08d87b9b7bb7b386da3baf.png";